export default __webpack_public_path__ + "static/media/clean_the_table.e998929e.png";